module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-trigger-bb9bcc0b.svg";